import { render, staticRenderFns } from "./AccountComponent.vue?vue&type=template&id=4c0f3125&scoped=true&"
import script from "./AccountComponent.vue?vue&type=script&lang=js&"
export * from "./AccountComponent.vue?vue&type=script&lang=js&"
import style0 from "./AccountComponent.vue?vue&type=style&index=0&id=4c0f3125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f3125",
  null
  
)

export default component.exports